import script from "./IntroButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroButton.vue?vue&type=script&setup=true&lang=ts"

import "./IntroButton.vue?vue&type=style&index=0&id=e8d55fbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d55fbc"]])

export default __exports__